import './modalConfirm.css';
import { useStoreContext } from '../../hooks/context/StoreContext';
import { ReactComponent as IconeAtencao } from '../../assets/icones/warning.svg';
import { useNavigate } from 'react-router-dom';
import { deletarTokenESessao } from '../../func/axiosInstance';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { logout } from '../../features/auth/logoutSlice';
import ButtonTemplate from '../buttonTemplate/ButtonTemplate';
import ReactFocusLock from 'react-focus-lock';
import SpinBtn from '../animation/SpinBtn';

const ModalConfirm = ({
  isOpen,
  closeModal,
  confirm,
  titulo,
  primeiroTexto,
  segundoTexto,
  styleTitleSecundary,
  loading = false
}) => {
  const { modal, setModal } = useStoreContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [apiCarregando, setApiCarregando] = useState(false);

  const handleFecharModal = (e) => {
    if (e.key === 'Escape') {
      setModal(prevModal => ({
        ...prevModal,
        openModalConfirm: false,
        openConfirmTabelaPreco: false
      }));

      closeModal();
    }
  };

  const handleConfirmar = async () => {
    if (modal.identificadorModalConfirm === 'token-expirado' || modal.identificadorModalConfirm === 'logout') {
      const limpezaGeral = modal.identificadorModalConfirm === 'token-expirado';
      
      try {
        setApiCarregando(true);
        await deletarTokenESessao(limpezaGeral);
        dispatch(logout());
        setModal(prev => ({ ...prev, openModalConfirm: false }));
        return navigate('/login');
      } catch (error) {
        console.log(error);
      } finally {
        setApiCarregando(false);
      };
    };

    if (confirm) confirm();
  };

  if (isOpen) {
    return (
      <div className='container' onKeyDown={handleFecharModal}>
        <ReactFocusLock>
          <div className='modal confirm'>
            <div className='modal-header confirm'>
              <IconeAtencao />
            </div>
            <div className='modal-body confirm'>
              <h3>{titulo}</h3>
              <p className='title-primary'>{primeiroTexto}</p>
              <p
                className='title-secundary'
                style={styleTitleSecundary}
              >
                {segundoTexto}
              </p>
            </div>
            <div className='modal-footer confirm'>
              <ButtonTemplate
                click={closeModal}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') closeModal();
                }}
              >
                Cancelar
              </ButtonTemplate>

              <ButtonTemplate
                apiCarregando={loading || apiCarregando}
                background={loading || apiCarregando ? '#00700093' : '#007000'}
                click={handleConfirmar}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleConfirmar();
                  }
                }}
              >
                {loading || apiCarregando ? <SpinBtn /> : 'Confirmar'}
              </ButtonTemplate>
            </div>
          </div>
        </ReactFocusLock>
      </div>
    );
  }

  return null;
};

export default ModalConfirm;
